import React from 'react';
import styles from './basket-amount.scss';

interface BasketAmountProps {
  basketItems: number;
}

export const BasketAmount = ({ basketItems }: BasketAmountProps) => (
  <>
    <span
      data-test="basket-amount"
      data-testid="basket-amount"
      className={basketItems > 0 ? styles.icon : styles.visuallyHidden}
    >
      {basketItems}
    </span>
    <span className={styles.visuallyHidden}>items in Basket</span>
  </>
);
